<template >
  <v-flex md10 offset-md1 class="pt-1" >
    <v-form style="width:100%" @submit.prevent="sendMessage">
      <v-text-field
        label="Solo"
        placeholder="Escreva sua mensagem"
        v-model="message"
        solo
        ref="message"
        >
      </v-text-field>
    </v-form>
  </v-flex>

</template>

<script>
export default {
  data () {
    return {
      message : ""
    }
  },
  methods : {
    async sendMessage(){
      let handle = this.$store.getters.HANDLE;
      if(this.message){
        let message = {
          user1 : handle.user1,
          user2 : handle.user2,
          handle : handle.handle,
          message : this.message
        }
        //let response = await this.$socket.client.emit('chat',message)
        this.message = ""
      }
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/chat/ChatBox.vue